import React, { useState } from "react";
import {
  Box,
  VStack,
  Text,
  Icon,
  Link as ChakraLink,
  Tooltip,
  IconButton,
  Button,
  useToast,
} from "@chakra-ui/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FiHome,
  FiPieChart,
  FiUser,
  FiMessageCircle,
  FiClipboard,
  FiDollarSign,
  FiChevronLeft,
  FiChevronRight,
  FiLogOut,
  FiHelpCircle,
} from "react-icons/fi";

/** -----------------------
 * Nav items (no locking)
 * --------------------- */
const navItems = [
  { name: "Dashboard", icon: FiHome, path: "/dashboard" },
  { name: "Free Resources", icon: FiClipboard, path: "/free-resources" },
  { name: "Submission Directory", icon: FiClipboard, path: "/submission-directory" },
  { name: "Pricing Tools", icon: FiDollarSign, path: "/pricing-tools" },
  { name: "CPG Advisors", icon: FiMessageCircle, path: "/advisors" },
  { name: "Charts", icon: FiPieChart, path: "/charts" },
  { name: "Account", icon: FiUser, path: "/account" },
  { name: "Contact Support", icon: FiHelpCircle, path: "/contact-support"},
];

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const [collapsed, setCollapsed] = useState(true);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("plan");
    localStorage.removeItem("user_plan");
    localStorage.removeItem("stripe_plan");
    toast({ title: "Logged out", status: "info", duration: 2000 });
    navigate("/login");
  };

  return (
    <Box
      w={collapsed ? "72px" : "200px"}
      bg="#1C4C3F"
      color="#F7F5EB"
      py={6}
      px={2}
      minH="100vh"
      boxShadow="xl"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      {/* Top Section */}
      <VStack align="start" spacing={6}>
        <Text
          fontSize="3xl"
          fontWeight="bold"
          color="#F7F5EB"
          ml={collapsed ? 0 : 4}
          alignSelf={collapsed ? "center" : "flex-start"}
        >
          {collapsed ? "SK" : "ShelfKey"}
        </Text>

        <VStack align="start" spacing={4} w="100%">
          {navItems.map((item) => {
            // active if exact match or a child route
            const isActive =
              item.path !== "#" &&
              (location.pathname === item.path ||
                location.pathname.startsWith(item.path + "/"));

            return (
              <Tooltip
                key={item.name}
                label={<Text fontWeight="bold">{item.name}</Text>}
                placement="right"
                hasArrow
                bg="#2F6B55"
                isDisabled={!collapsed}
              >
                <ChakraLink
                  as={Link}
                  to={item.path}
                  display="flex"
                  alignItems="center"
                  w="100%"
                  px={collapsed ? 0 : 3}
                  py={2}
                  borderRadius="md"
                  bg={isActive ? "#2F6B55" : "transparent"}
                  color="#F7F5EB"
                  _hover={{ bg: "#2F6B55" }}
                >
                  <Icon as={item.icon} boxSize={5} />
                  {!collapsed && (
                    <Text ml={3} fontSize="md">
                      {item.name}
                    </Text>
                  )}
                </ChakraLink>
              </Tooltip>
            );
          })}
        </VStack>
      </VStack>

      {/* Bottom Section */}
      <VStack spacing={4}>
        {!collapsed && (
          <Button
            onClick={handleLogout}
            leftIcon={<FiLogOut />}
            size="sm"
            w="100%"
            bg="#2F6B55"
            _hover={{ bg: "#3F8269" }}
            color="#F7F5EB"
          >
            Logout
          </Button>
        )}

        <Tooltip
          label={collapsed ? "Expand" : "Collapse"}
          placement="right"
          hasArrow
          bg="#2F6B55"
        >
          <IconButton
            aria-label="Toggle Sidebar"
            icon={collapsed ? <FiChevronRight /> : <FiChevronLeft />}
            onClick={() => setCollapsed(!collapsed)}
            bg="transparent"
            _hover={{ bg: "#2F6B55" }}
            color="#F7F5EB"
            size="sm"
          />
        </Tooltip>
      </VStack>
    </Box>
  );
};

export default Sidebar;
